// 券宝宝服务条款。
//
// 2026-09-18 整页重写。此前这里挂的是德国 Triple A Marketing GmbH 的模板，
// 通篇是别人的公司名。
//
// 正文来自律师起草的两份 docx（AI 博主服务 · 商家条款 / 博主条款，2026-09-13 版），
// 用脚本抽进 src/legal/termsData.json，**没有手工重打**：几十万字节的法律文本
// 手抄一定会抄错，而抄错一个「不」字就是另一层意思。要改条款改那个 JSON。
//
// 跟原件相比只动了一处：隐私相关的章节（商家 8 / 11、博主 9 / 10）整节移入
// 《隐私政策》，原位置留一句指向它的话。隐私政策依法应当是一份对所有人公开、
// 独立可访问的文件，不能只作为某一份合同的一章 —— 而且原来商家看不到博主条款
// 第 9 节、博主看不到商家条款第 8 节，那两段讲的却是同一套数据处理实践。
//
// 商家条款 8.5 / 8.6 特意留在条款里没有跟着移走：那两条是**商家对我们的承诺**
// （不得抓取转售博主信息、提供第三方信息要有合法依据），属于合同义务而不是
// 隐私告知。放进隐私政策就失去合同效力，出事时没法据以追究。

import React, { useState } from 'react';
import LegalDoc from '../legal/LegalDoc';
import terms from '../legal/termsData.json';

const TITLE = {
  zh: '券宝宝服务条款',
  en: 'Couponer Terms of Service',
};

const LEDE = {
  zh: '按身份分成两部分：商家看第一份，博主看第二份。两份都受澳大利亚法律管辖，都不排除依法不可排除的消费者权利。',
  en: 'Two parts by role: Merchants read the first, Creators the second. Both are governed by Australian law and neither excludes consumer rights that cannot be excluded by law.',
};

const TABS = [
  { key: 'merchant', label: { zh: '商家条款', en: 'Merchant Terms' } },
  { key: 'creator', label: { zh: '博主条款', en: 'Creator Terms' } },
];

export default function UserProtocol() {
  const [tab, setTab] = useState('merchant');

  return (
    <LegalDoc
      docKey="terms"
      titleOf={(l) => TITLE[l]}
      ledeOf={(l) => LEDE[l]}
      sectionsOf={(l) => terms[tab][l]}
      updated="2026-09-20"
      tabs={TABS}
      activeTab={tab}
      onTab={setTab}
      footLinks={[
        { href: '#/privacyPolicy', label: { zh: '隐私政策', en: 'Privacy Policy' } },
      ]}
    />
  );
}
